import React from 'react'
import Grid from '@material-ui/core/Grid'
import marketingImage from '../../images/img-churrasqueira.jpg'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

const useStyles = makeStyles((theme) => ({
    websitesContainer: {
        backgroundColor: "#efefef",
        display: "flex",
        flexFlow: "column-reverse",
        margin: "auto",
        textAlign: "center",
        paddingBottom: "5vw !important",
        paddingLeft: "8vw !important",
        paddingRight: "8vw !important",
        maxWidth: "100%",
        [theme.breakpoints.up('md')]: {
            flexFlow: "inherit",
            paddingTop: "15px",
            maxWidth: "100%"  
        }
    },
    websitesLeftDiv: {
        maxWidth: "100%",
        margin: "auto",
        paddingLeft: "4vw !important",
        paddingRight: "4vw !important",
        [theme.breakpoints.up('md')]: {
            textAlign: "left",
            paddingTop: "8vw!important",
            paddingLeft: "4vw !important",
            marginTop: "0px",
            backgroundColor: "transparent"
        }
    },
    websitesRightDiv: {
        maxWidth: "100%",
    },

    websitesText: {
        color: "#548794",
        fontFamily: "Oswald, sans-serif",
        fontWeight: 700,
        fontSize: "34px",
        textTransform: "uppercase",
        maxWidth: "450px",
        lineHeight: "35px",
        margin: "auto",
        [theme.breakpoints.up('md')]: {
            marginLeft: "0px"
        }
    },
    websitesTextArea: {
        fontFamily: "Poppins, sans-serif",
        fontSize: "18px",
        color: "#606060",
        lineHeight: "35px",
        margin: "auto",
        marginTop: "15px"
    },
    websitesImage: {
        objectFit: "cover",
        height: "auto",
        width: "80%",
        [theme.breakpoints.up('md')]: {
            width: "100%",
        }
    },
}));

export default function SanPaoloDetails3() {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid id="details3" container spacing={3} className={classes.websitesContainer}>
            <Grid id="details3Div" item xs={6} className={classes.websitesLeftDiv}>
                    <Fade left>
                        <p className={classes.websitesText}>Nosso diferencial é o conforto e a tecnologia</p>
                    </Fade>
                    <Fade>
                        <p className={classes.websitesTextArea}>
                            Eficiência com plantas inteligentes, muita luz natural e infraestrutura para instalações completas. Pensando sempre em melhorias sustentáveis e tecnologia, o empreendimento tem iluminação de LED nas áreas comuns, aproveitamento de águas pluviais para rega de jardinagem e muito mais!
                        </p>
                    </Fade>
            </Grid>
            <Grid id="websitesRight" item xs={6} className={classes.websitesRightDiv}>
                <img src={marketingImage} alt="websites" className={classes.websitesImage} />
            </Grid>
        </Grid>
    )
}
